(() => {
  const init = (scope = document) => {
    const root = scope.matches?.('#bn-landing') ? scope : scope.querySelector('#bn-landing');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('#bn-product-form');
    const quantity = form?.querySelector('[name="quantity"]');
    const offers = root.querySelector('#bn-ofertas');
    if (!form || !quantity || !offers) return;
    const choices = [...root.querySelectorAll('[data-bn-pack]')];
    function select(value) {
      choices.forEach(input => { input.checked = input.value === value; });
      quantity.value = value;
      quantity.setAttribute('value', value);
      quantity.dispatchEvent(new Event('input', {bubbles:true}));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
      const selected = choices.find(input => input.value === value);
      root.querySelectorAll('[data-bn-summary]').forEach(el => { el.textContent = selected.dataset.summary; });
    }
    choices.forEach(input => input.addEventListener('change', () => select(input.value)));
    select(choices.find(input => input.checked)?.value || '2');
    const polishNativeButton = () => {
      const button = root.querySelector('#_rsi-buy-now-button');
      if (!button) return;
      const styles = {background:'linear-gradient(110deg,#c79e49,#ffe0a0,#d8b05d)',color:'#152218','border-radius':'40px',border:'1px solid #f3d994'};
      Object.entries(styles).forEach(([key,value]) => {
        if (button.style.getPropertyValue(key) !== value) button.style.setProperty(key,value,'important');
      });
      if (!button.dataset.bnAccessible) {
        button.dataset.bnAccessible='true';
        button.setAttribute('role','button');
        button.tabIndex=0;
        button.addEventListener('keydown', event => {
          if (event.key==='Enter' || event.key===' ') {event.preventDefault();button.click();}
        });
      }
    };
    polishNativeButton();
    new MutationObserver(polishNativeButton).observe(form,{childList:true,subtree:true});
    root.querySelectorAll('[data-bn-to-offers]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      offers.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
      offers.focus({preventScroll:true});
    }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
